module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"markComplete":"Mark as complete","markIncomplete":"Mark as incomplete","errorUpdatingTask":"Error updating task","errorCompletingTask":"At least one task outcome must be selected"}}')
  delete Component.options._Ctor
}
